import React, { useState } from "react";
import api from "../../api/axios.tsx"; // Make sure to install axios if you haven't already
import { useNavigate, Link } from "react-router-dom";
import Button from "../../components/ui/button.tsx";
import Input from "../../components/ui/input.tsx";
import Label from "../../components/ui/label.tsx";
import { GoogleLogin } from "@react-oauth/google";

const Register = () => {
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();

    api
      .post("/auth/register", { password, email })
      .then((response) => {
        // const { access_token, ...user } = response.data;

        // Store the token
        localStorage.setItem("user", JSON.stringify(response.data));

        // Redirect user to dashboard or another route
        navigate("/dashboard");
      })
      .catch((error) => {
        console.error("Login failed:", error);
        // Show error to user if needed
      });
  };

  return (
    <div className="page flex items-center justify-center p-4">
      <div className="w-full max-w-md p-8 card-glass relative z-10">
        <div className="text-center">
          <div className="eyebrow inline-block mb-4">Create account</div>
          <h1 className="heading-2 text-center text-glow">Let's get started</h1>
          <p className="subheading">
            Join Budiee and start organizing your money.
          </p>
        </div>
        <form className="flex flex-col mt-6" onSubmit={handleSubmit}>
          <Label htmlFor="email" className="mb-1">
            Email
          </Label>
          <Input
            id="email"
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="mb-4"
          />
          <Label htmlFor="password" className="mb-1">
            Password
          </Label>
          <Input
            id="password"
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="mb-2"
          />
          <Button type="submit" className="mt-4 btn-primary w-full">
            Sign Up
          </Button>
        </form>
        <div className="mt-6 flex items-center gap-3">
          <div className="h-px bg-white/15 w-full" />
          <span className="text-xs text-white/70 text-nowrap">
            Or
          </span>
          <div className="h-px bg-white/15 w-full" />
        </div>
        <div className="mt-4 flex flex-col gap-3">
          <GoogleLogin
            onSuccess={(res) => {
              const idToken = res.credential;
              api
                .post(
                  "/auth/google/token",
                  { id_token: idToken },
                  { headers: { "Content-Type": "application/json" } }
                )
                .then((response) => {
                  const data = response.data;
                  if (data) {
                    localStorage.setItem("user", JSON.stringify(data));
                    navigate("/dashboard");
                  }
                })
                .catch((error) => {
                  console.error("Google registration/login failed:", error);
                });
            }}
            onError={() => {
              console.error("Google SSO Failed");
            }}
            theme="filled_black"
            size="large"
            text="continue_with"
            shape="pill"
            width="360"
          />
        </div>
        <div className="mt-6 text-center text-sm text-gray-400">
          <p>
            Already have an account?{" "}
            <Link className="text-blue-400 hover:underline" to="/auth">
              Log in
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Register;
